export const environment = {
    production: true,
    APIHOSTPREFIX: '/v1'
};
